import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { ItemGroupCheckbox } from "~/components/BatchEdit/ItemGroupCheckbox";
import { GroupHeader } from "./GroupHeader";

export const Group = ({ date, total, children, className, items, ...rest }) => {
  return (
    <div className="tw-mb-6 last:tw-mb-0">
      <div className="tw-flex tw-ml-1">
        <ItemGroupCheckbox
          id={date}
          items={items}
        />
        <GroupHeader
          date={date}
          total={total}
          className={classNames("tw-mb-2", className)}
          {...rest}
        />
      </div>

      {children}
    </div>
  );
};

Group.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  total: PropTypes.number.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  items: PropTypes.array,
};

Group.defaultProps = {
  items: [],
};
